import { useRecoilValue } from 'recoil';
import { blockDateRange, blockDisplayHeader, customizedBlock } from 'venn-state';
import React from 'react';
import { Block } from '../../components/core';
import { useAnalysis } from '../../../studio-blocks/logic/useAnalysis';
import { Dates } from 'venn-utils';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';

type OptionsPerformanceSummaryHeaderProps = Readonly<{
  id: string;
}>;

const AsOfDate = ({ id }: { id: string }) => {
  const { analyses } = useAnalysis(id);

  const response = analyses?.[0]?.[0]?.optionsPerformanceSummaryResponses?.[0];

  const asOfDate = response?.asOfDate;

  if (!asOfDate) {
    return null;
  }

  return (
    <Block.Metadata id={id}>
      <Block.MetadataItem iconType="calendar">As of {Dates.toDDMMMYYYY(asOfDate, 'DAILY')}</Block.MetadataItem>
    </Block.Metadata>
  );
};

export const OptionsPerformanceSummaryHeader = ({ id }: OptionsPerformanceSummaryHeaderProps) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const { subHeader } = useRecoilValue(customizedBlock(id));
  const dateRange = useRecoilValue(blockDateRange(id));

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>
        {dateRange && <AsOfDate id={id} />}
      </Block.HeaderTopContainer>
      <DefaultSubjects id={id} relativeToBenchmark={false} />
    </>
  );
};
